import { render, staticRenderFns } from "./videoMessage.vue?vue&type=template&id=1e3fe3b7&scoped=true&"
import script from "./videoMessage.vue?vue&type=script&lang=js&"
export * from "./videoMessage.vue?vue&type=script&lang=js&"
import style0 from "./videoMessage.vue?vue&type=style&index=0&id=1e3fe3b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3fe3b7",
  null
  
)

export default component.exports